<div *ngIf="cart" class="flow-root">
    <ul role="list" class="divide-y divide-gray-200">
        <ng-container *ngFor="let line of cart.lines; trackBy: trackByFn">
            <li class="py-6 flex flex-col">
                <div class="flex flex-row">
                    <div class="flex-shrink-0 w-24 flex flex-col">
                        <div class="h-24 border border-gray-200 rounded-md overflow-hidden">
                            <ng-container *ngIf="!line.customizationPreviewUrl; else customizedImage">
                                <img [src]="(line.featuredAsset || line.productVariant.featuredAsset) | assetPreview:'thumb':'webp'"
                                     [alt]="line.productVariant.name"
                                     style="pointer-events: none;"
                                     class="rounded w-full h-full aspect-[1/1]"/>
                            </ng-container>
                            <ng-template #customizedImage>
                                <img [src]="line.customizationPreviewUrl" alt="Customization Preview" class="w-full h-full object-cover"/>
                            </ng-template>
                        </div>
                        <div *ngIf="enableReview" class="mt-2 wide-button">
                            <button *ngIf="!reviewStatusMap.get(line.productVariant.product.id)"
                                    class="btn border rounded bg-yellow-400 text-white hover:bg-blue-400 w-full text-xs cursor-pointer"
                                    (click)="openInputProductReviewForm(line)">
                                Write a review
                            </button>
                            <button *ngIf="reviewStatusMap.get(line.productVariant.product.id) && reviewStatusMap.get(line.productVariant.product.id).status!=='loading'"
                                    class="btn border rounded bg-grey-700 text-[#2E3742] w-full text-xs"
                                    disabled
                                    >
                                Reviewed
                            </button>
                        </div>
                    </div>
                    <div class="ml-4 flex-1 flex flex-col">
                        <div>
                            <div class="flex justify-between text-base font-medium text-gray-900">
                                <p>
                                    <a [routerLink]="[ baseProductUrl, line.productVariant.product.slug ]"
                                       [queryParams]="{ variantid: line.productVariant.id }">
                                        {{ line.productVariant.name }}
                                    </a>
                                </p>
                                <p class="ml-4">
                                    {{ (line.unitPrice*line.quantity) | formatPrice }}
                                </p>
                            </div>
                        </div>

                        <div class="flex-1 flex items-center justify-between text-sm text-gray-600">
                            <div class="flex space-x-4">
                                <button class="btn btn-sm"
                                        *ngIf="canAdjustQuantities"
                                        (click)="decrement(line)">
                                    <fa-icon aria-label="Remove 1" icon="minus"></fa-icon>
                                </button>
                                <div class="qty">{{ line.quantity }}</div>
                                <button class="btn btn-sm"
                                        *ngIf="canAdjustQuantities"
                                        (click)="increment(line)">
                                    <fa-icon aria-label="Add 1" icon="plus"></fa-icon>
                                </button>
                            </div>
                            <div class="total">
                                <div class="">
                                    {{ line.unitPrice | formatPrice }}
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <div *ngIf="line.orderedCustomizableAssets?.length" class="mt-2 mb-2 w-full max-w-full">
                    <vsf-cart-line-customization
                        [optionName] = "line.customizationOptionName"
                        [assets]="line.orderedCustomizableAssets">
                    </vsf-cart-line-customization>
                </div>
            </li>
        </ng-container>
    </ul>
    <div *ngIf="editOrderMessage">
        <vsf-order-message-form
          [orderMessage]="cart.customFields?.message">
        </vsf-order-message-form>
    </div>
    <div *ngIf="!editOrderMessage && cart.customFields?.message">
        <label class="block text-sm font-medium text-gray-700 mt-4 mb-1">Order Note</label>
        <textarea
            readonly
            rows="6"
            class="w-full m-0 p-0 text-left text-gray-500 border-0 focus:ring-0 focus:outline-none resize-none
                    bg-transparent shadow-none appearance-none whitespace-pre-wrap break-words leading-none"
            [value]="cart?.customFields?.message || ''">
        </textarea>
    </div>
</div>
